import { render } from "./FullName.vue?vue&type=template&id=164b3801&lang=pug"
import script from "./FullName.vue?vue&type=script&lang=js"
export * from "./FullName.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__